module.exports = __webpack_public_path__ + "static/media/pdf-icon.e900a7bf.svg";